import React from 'react'
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import Redirect from "../../helpers/Redirect";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import Colors from "../../config/colors";
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CardHeader from "@material-ui/core/CardHeader";
import AppInputText from "../../ui/AppInputText";
import {Link} from "react-router-dom";
import AppButton from "../../ui/AppButton";
import Header from "../../components/Header";
import {withRouter} from 'react-router';

class RecoverPassword extends React.Component {

    state = {
        email: '',
        url: ''
    };

    validate = () => {
        if (String(this.state.email).trim() === '') {
            AppToast('Debe ingresar el email!', false);
            return false;
        }
        return true;
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        // Valida los campos obligatorios
        if (!this.validate()) {
            return;
        }

        let params = {terceroMail: this.state.email}
        const data = await Api.post(`${Env.UrlSeguridad}/postRecuperarPassword`, params);
        if (data.cod === '1') {
            AppToast('La contraseña se recuperó con éxito, revise su correo!', true);
            this.setState({
                url: '/'
            });
        } else {
            AppToast(data.msg, false);
        }
    }

    handleChange = (e) => {
        this.setState({
            email: e.target.value
        });
    }

    render() {
        return (
            <div className='container-form'>
                <Redirect url={this.state.url}/>

                <Header />

                <div>
                    <form onSubmit={this.handleSubmit}>
                        <Grid
                            container
                            direction="column"
                            justify="flex-start"
                            alignItems="center">

                            <Card className='container-login'>

                                <Avatar style={{background: Colors.accent, marginLeft: '45%'}}>
                                    <LockOpenIcon />
                                </Avatar>

                                <CardHeader title="Recuperar contraseña"/>

                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <AppInputText
                                            id='email'
                                            name='email'
                                            value={this.state.email}
                                            label='Email'
                                            onChange={this.handleChange}
                                            required={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppButton
                                            type='submit'
                                            label='Recuperar'
                                            size='large'
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{padding: '15px'}}>
                                        <Link to='/' variant="body2">
                                            {"Volver"}
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </form>
                </div>
            </div>
        );
    }

}

export default withRouter(RecoverPassword)

